import type { PaginationControlStatus } from '@disy/ui/pagination-control-status';
import type { PaginationControlStepper } from '@disy/ui/pagination-control-stepper';

import i18n from './pagination-i18n.properties';

/**
 * The {@link PaginationControl} is reused between {@link BaseTable} and {@link ResponsiveTable}.
 * In the `BaseTable`, different messages should be used. For not having to duplicate a lot of code,
 * we use this small utility, which returns different messages based on the context.
 */
export function paginationI18n(
  pagination: PaginationControlStatus | PaginationControlStepper,
  key: string,
  options?: Record<string, unknown>,
) {
  return i18n(`${pagination.closest('.d-table') ? 'rows' : 'results'}.${key}`, options);
}
